<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="row align-items-center justify-content-between">
					<div class="col-12">
						<h4 class="mt-2 mb-4 pb-2 pt-2">Create LHCSA</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12">
			<organization-detail-form :organization_data="organization_data"
			@onSubmit="onSubmit" />
			</div>
		</div><!--row-->
	</div>
</template>

<script>
import OrganizationDetailForm from './shared/OrganizationDetailForm';
import PhoneCountryCode from '../../shared/inputs/PhoneCountryCode'
export default {
	data : function(){
		return {
			organization_data : {
				name : '',
				display_name : '',
				country_code:'',
				year_founded : '',
				became_costumer : '',
				purchased_hours : '',
				contact_name : '',
				contact_email : '',
				contact_phone : '',
				image : null,
			},
			organization_id : null,
			colours : {
			  hex: '#194d33',
			  hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
			  hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
			  rgba: { r: 25, g: 77, b: 51, a: 1 },
			  a: 1
			},
		    current_step : [
		    	false,
		    	true,
		    	false,
		    	false
		    ],
		    step_completed : [
				false,
		    	false,
		    	false,
		    	false
		    ],
			courses : [],
			courses_selected : [],
			import_result : null,

		}
	},
	watch:{
		'organization_data.phone':function(val){
			var removedText = val.replace(/\D+/g, '');
			this.organization_data.phone = removedText
		}
	},
	components: {
		PhoneCountryCode,
		OrganizationDetailForm
	},
	created : function(){
		
	},
	computed : {
		can_step_three : function(){
			return this.courses_selected.length > 0;
		}
	},
	methods : {
		onSubmit : function(){
			this.$validator.validateAll().then((result) => {
				if(result){
					this.organization_data.colour = this.colours.hex;
					if(typeof this.organization_data.country_code == 'object'){
						this.organization_data.country_code = this.organization_data.country_code.value;
					}
					this.$store.dispatch('createOrganization', this.organization_data).then((res) => {
						this.$router.push({ name : 'admin.organizations.detail', params : { agency_id : res.data.organization.id } });
					}).catch((error) => {
						
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/AdminOrganizationCreateComponent.vue